import React from "react";
import { useInView } from "react-intersection-observer";

import { FaHtml5, FaCss3, FaReact, FaGithub } from "react-icons/fa";
import { TbBrandNextjs } from "react-icons/tb";
import { TbBrandJavascript } from "react-icons/tb";
import { SiTailwindcss } from "react-icons/si";

const Skills = () => {
  // intersection observer
  const { ref: skillSectionTitleRef, inView: skillSectionTitleIsVisible } =
    useInView({
      triggerOnce: true,
    });

  const { ref: skillOneRef, inView: skillOneIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: skillTwoRef, inView: skillTwoIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: skillThreeRef, inView: skillThreeIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: skillFourRef, inView: skillFourIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: skillFiveRef, inView: skillFiveIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: skillSixRef, inView: skillSixIsVisible } = useInView({
    triggerOnce: true,
  });
  const { ref: skillSevenRef, inView: skillSevenIsVisible } = useInView({
    triggerOnce: true,
  });

  return (
    <section className="skills-section" id="skill-section">
      <div className="skills-div">
        <div className="skills-title-div">
          <h1
            ref={skillSectionTitleRef}
            className={`${
              skillSectionTitleIsVisible
                ? "skills-title show-title"
                : "skills-title"
            }`}
          >
            Web Skills
          </h1>
          <div className="title-underline"></div>
        </div>

        <ul className="skills-ul">
          <li
            ref={skillOneRef}
            className={`${
              skillOneIsVisible ? "skill-one show-skill-one" : "skill-one"
            }`}
          >
            <div className="skill-div">
              <TbBrandJavascript className="skill-icon" />
              <div className="skill-and-howskilled-div">
                <span className="skill">JavaScript</span>
              </div>
            </div>
          </li>
          <li
            ref={skillTwoRef}
            className={`${
              skillTwoIsVisible ? "skill-two show-skill-two" : "skill-two"
            }`}
          >
            <div className="skill-div">
              <FaReact className="skill-icon" />
              <div className="skill-and-howskilled-div">
                <span className="skill">React</span>
              </div>
            </div>
          </li>
          <li
            ref={skillThreeRef}
            className={`${
              skillThreeIsVisible
                ? "skill-three show-skill-three"
                : "skill-three"
            }`}
          >
            <div className="skill-div">
              <TbBrandNextjs className="skill-icon" />
              <div className="skill-and-howskilled-div">
                <span className="skill">Next.js</span>
              </div>
            </div>
          </li>
          <li
            ref={skillFourRef}
            className={`${
              skillFourIsVisible ? "skill-four show-skill-four" : "skill-four"
            }`}
          >
            <div className="skill-div">
              <SiTailwindcss className="skill-icon" />
              <div className="skill-and-howskilled-div">
                <span className="skill">Tailwind</span>
              </div>
            </div>
          </li>
          <li
            ref={skillFiveRef}
            className={`${
              skillFiveIsVisible ? "skill-five show-skill-five" : "skill-five"
            }`}
          >
            <div className="skill-div">
              <FaCss3 className="skill-icon" />
              <div className="skill-and-howskilled-div">
                <span className="skill">CSS3</span>
              </div>
            </div>
          </li>
          <li
            ref={skillSixRef}
            className={`${
              skillSixIsVisible ? "skill-six show-skill-six" : "skill-six"
            }`}
          >
            <div className="skill-div">
              {/* <FaNodeJs className="skill-icon"/> */}
              <FaHtml5 className="skill-icon" />
              <div className="skill-and-howskilled-div">
                <span className="skill">HTML5</span>
              </div>
            </div>
          </li>
          <li
            ref={skillSevenRef}
            className={`${
              skillSevenIsVisible
                ? "skill-seven show-skill-seven"
                : "skill-seven"
            }`}
          >
            <div className="skill-div">
              <FaGithub className="skill-icon" />
              <div className="skill-and-howskilled-div">
                <span className="skill">GitHub</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Skills;
